<template lang="pug">
  y-dialog(v-model="showModal"
           fill-height fluid scrollable persistent
           transition="fade-transition" max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('select_product') }}
      v-divider.basic300
      v-card-text.px-4.text-center
        div.pb-0
          v-text-field.mt-4(v-model="searchFilter.searchText"
                            placeholder="Search product"
                            height="40" background-color="basic200"
                            hide-details dense outlined )
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          y-checkbox.mt-2(v-model="searchFilter.hideSubProduct" hide-details)
            template(v-slot:label)
              div.p1.primary--text {{ $t('hide_variant_add_on') }}
        div
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align="center" justify="center")
              v-progress-circular.ma-auto(width="2" size="50" color="primary" indeterminate)
          .content(v-else)
            v-layout.my-6(v-if="products.length == 0")
              v-row.fill-height.ma-0(align="center" justify="center")
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('products_not_found') }}
            div.mt-4(v-else)
              v-card(outlined)
                v-list.pa-0
                  div(v-for='(product, index) in products')
                    v-divider(v-if="index != 0")
                    v-list-item(:key='product.id' @click="selectItem(product)")
                      v-layout.text-left
                        v-list-item-avatar(tile)
                          v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')")
                        v-list-item-content
                          div.p1.basic800--text(v-text="product.display_name")
                          v-list-item-title.c2.basic600--text {{ product.price | displayPrice }}
              div.mt-4
                y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('close') }}

</template>

<script>
//import { mapActions } from 'vuex'
export default {
  name: 'ProductFilterDialog',
  props: ['open', 'company'],
  data: () => ({
    isFetching: true,
    products: [],
    pageSize: 10,
    count: 0,
    page: 1,
    searchFilter: {
      searchText: '',
      hideSubProduct: false
    },
    searchCountDown: null,
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page () {
      if (!this.isFetching) {
        this.fetchProducts()
      }
    },
    searchFilter:{
      handler(){
        if (this.searchCountDown) clearTimeout(this.searchCountDown)
        this.searchCountDown = setTimeout(() => {
          this.page = 1
          this.fetchProducts()
        }, 500)
      },
      deep: true
    }
  },
  mounted () {
    this.fetchProducts()
  },
  methods: {
    filterParams () {
      return {
        company: this.company.id,
        page: this.page,
        page_size: this.pageSize,
        has_sales: true,
        include_deleted: true,
        include_sub_product: !this.searchFilter.hideSubProduct,
        search: this.searchFilter.searchText,
        ordering: "-id"
      }
    },
    fetchProducts () {
      this.isFetching = true
      this.$axios.get('/products/', { params: this.filterParams() })
        .then(response => {
          this.products = response.data.results
          this.count = response.data.count
        }).catch(() => {}).finally(() => { this.isFetching = false })
    },
    selectItem (product) {
      this.showModal = false
      this.$emit('selected', product)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "select_product": "Select Product",
    "hide_variant_add_on": "Hide variant and add-on products"
  },
  "id": {
    "select_product": "Pilih Produk",
    "hide_variant_add_on": "Sembunyikan varian dan produk tambahan"
  }
}
</i18n>
